import get from 'lodash/get'

export const isEmailEnabled = (channelData, emailName) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled }) => name === emailName && enabled === true)

}
